export default function LinkIcon() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0955 17.1301C13.7935 16.8282 13.3032 16.8282 13.0013 17.1301L12.9497 17.1818C12.1316 17.9998 11.0426 18.4514 9.88387 18.4514C7.49419 18.4514 5.54839 16.5056 5.54839 14.116C5.54839 12.9572 6 11.8682 6.81806 11.0501L6.86968 10.9985C7.01677 10.8514 7.09677 10.6579 7.09677 10.4514C7.09677 10.245 7.01677 10.0514 6.86968 9.90434C6.72258 9.75725 6.52129 9.67725 6.32258 9.67725C6.12387 9.67725 5.92516 9.75209 5.77548 9.90434L5.72387 9.95596C4.61161 11.0682 4 12.5443 4 14.116C4 17.3598 6.64 19.9998 9.88387 19.9998C11.4555 19.9998 12.9342 19.3882 14.0439 18.276L14.0955 18.2243C14.2426 18.0772 14.3226 17.8837 14.3226 17.6772C14.3226 17.4708 14.2426 17.2772 14.0955 17.1301Z"
        fill="currentColor"
      />
      <path
        d="M14.1162 4C12.5446 4 11.0685 4.61161 9.9562 5.72387L9.90459 5.77548C9.75749 5.92258 9.67749 6.11613 9.67749 6.32258C9.67749 6.52903 9.75749 6.72258 9.90459 6.86968C10.1962 7.16129 10.7072 7.16129 10.9988 6.86968L11.0504 6.81806C11.8685 6 12.9575 5.54839 14.1162 5.54839C16.5059 5.54839 18.4517 7.49419 18.4517 9.88387C18.4517 11.0426 18.0001 12.1316 17.182 12.9497L17.1304 13.0013C16.9833 13.1484 16.9033 13.3419 16.9033 13.5484C16.9033 13.7548 16.9833 13.9484 17.1304 14.0955C17.422 14.3871 17.933 14.3871 18.2246 14.0955L18.2762 14.0439C19.3859 12.9342 19.9975 11.4555 19.9975 9.88387C19.9975 6.64 17.3575 4 14.1136 4H14.1162Z"
        fill="currentColor"
      />
      <path
        d="M14.6117 10.4824C14.7588 10.3353 14.8388 10.1418 14.8388 9.93533C14.8388 9.72887 14.7588 9.53533 14.6117 9.38823C14.462 9.23855 14.2633 9.16113 14.0646 9.16113C13.8659 9.16113 13.6672 9.23597 13.5175 9.38823L9.38847 13.5173C9.24138 13.6644 9.16138 13.8579 9.16138 14.0644C9.16138 14.2708 9.24138 14.4644 9.38847 14.6115C9.68009 14.9031 10.1911 14.9031 10.4827 14.6115L14.6117 10.4824Z"
        fill="currentColor"
      />
    </svg>
  );
}
